<section class="section-padding about-section" id="about" *ngIf="content$ | async as content">
  <div class="container">
    <div class="about-grid">
      <div class="about-content">
        <span class="subtitle">{{ content?.subtitle || 'Our Story' }}</span>
        <h2>{{ content?.title || 'Rooted in tradition. Baked for today.' }}</h2>
        <p>{{ content?.story || 'At The Husk Bakery, we believe that great bread takes time. We started as a small local stall at the weekend markets, driven by a passion for traditional sourdough fermentation.\n\nToday, our artisan bakers still wake up before dawn to mix, shape, and bake every loaf by hand. We use only organic, locally milled flour, filtered water, and Australian sea salt. No shortcuts. Just dedication to the craft.' }}</p>
        <div class="about-stats" *ngIf="!content?.values || content.values.length === 0">
          <div class="stat"><span class="number">48h</span><span class="label">Fermentation</span></div>
          <div class="stat"><span class="number">100%</span><span class="label">Organic Flour</span></div>
          <div class="stat"><span class="number">0</span><span class="label">Additives</span></div>
        </div>
        <div class="about-stats" *ngIf="content?.values && content.values.length > 0">
          <div class="stat" *ngFor="let val of content.values">
            <span class="label" style="font-weight: 500; font-size: 1.1rem; color: #d37330;">{{ val }}</span>
          </div>
        </div>
      </div>
      <div class="about-image-wrapper">
        <img [src]="getImgSrc(content?.teamPhoto)" alt="About Us" class="about-image">
      </div>
    </div>
  </div>
</section>

